import { apiClient } from "@nimbus-erp/api-client";
import { useQuery } from "@tanstack/react-query";
import { Spin } from "antd";
import { useEffect, type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../store/authStore";

export function AdminGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { user, initialized, setInitialized, setSession } = useAdminAuth();
  const query = useQuery({
    queryKey: ["platform-session"],
    queryFn: apiClient.me,
    enabled: !initialized,
    retry: false,
  });
  useEffect(() => {
    if (initialized) return;
    if (query.data) setSession(query.data);
    if (query.isError) {
      setSession(null);
      setInitialized(true);
    }
  }, [initialized, query.data, query.isError, setInitialized, setSession]);
  if (!initialized)
    return (
      <div className="admin-loading">
        <Spin size="large" />
        <strong>校验平台权限</strong>
      </div>
    );
  if (!user || user.loginType !== "PLATFORM")
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}
